import apiClient from './api';
import { validateRequiredParams } from '@/utils/apiUtils';
import {
  CreativeDimensionItem,
  CreativeDimensionsResponse,
  CreativeDimensionsRankParams,
  CreativeDimensionsByBrandParams,
  CreativeDimensionsByBrand,
  DimensionBrandAverage,
} from '@/types/creative.types';

function pickBrandLabel(row: Record<string, unknown>): string {
  const candidates = [row.brand, row.hashtag_name, row.account_group_name, row.name];
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim() !== '') return c.trim();
  }
  return '';
}

function normalizeDimensionBrandRow(raw: Record<string, unknown>): DimensionBrandAverage {
  const avgRaw = raw.avg ?? raw.average ?? raw.score;
  const avg = typeof avgRaw === 'number' ? avgRaw : Number(avgRaw);
  return {
    brand: pickBrandLabel(raw),
    avg: Number.isFinite(avg) ? avg : 0,
  };
}

function normalizeDimensionsByBrand(data: CreativeDimensionsByBrand): CreativeDimensionsByBrand {
  const result: CreativeDimensionsByBrand = {};
  for (const key of Object.keys(data)) {
    const rows = data[key];
    if (!Array.isArray(rows)) continue;
    result[key] = rows.map(row =>
      normalizeDimensionBrandRow(row as unknown as Record<string, unknown>)
    );
  }
  return result;
}

export const creativeService = {
  async getCreativeDimensionsRank(
    params: CreativeDimensionsRankParams
  ): Promise<CreativeDimensionItem[]> {
    validateRequiredParams(params, ['tenant_code']);
    validateRequiredParams(params, ['account_group_codes']);

    const { tenant_code, ...queryParams } = params;

    const response = await apiClient.get<CreativeDimensionsResponse>(
      `/creative/${encodeURIComponent(tenant_code)}/dimensions-rank`,
      { params: queryParams }
    );
    return response.data.data;
  },

  async getCreativeDimensionsByBrand(
    params: CreativeDimensionsByBrandParams
  ): Promise<CreativeDimensionsByBrand> {
    validateRequiredParams(params, ['tenant_code']);
    validateRequiredParams(params, ['account_group_codes']);

    const { tenant_code, ...queryParams } = params;

    // Tipamos la respuesta para esperar el wrapper { data: ... }
    const response = await apiClient.get<{ data: CreativeDimensionsByBrand }>(
      `/creative/${encodeURIComponent(tenant_code)}/dimensions-by-brand`,
      { params: queryParams }
    );

    return normalizeDimensionsByBrand(response.data.data);
  },
};
